"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iLinkedFolder = exports.iLinkFolders = exports.iLinkModes = exports.PATH = exports.ROOT = exports.iDisconnectVektorioProjects = exports.iConnectVektorioProjects = exports.iVektorioProject = exports.iVektorioApiKey = exports.iVektorioSyncStatus = exports.VektorioSyncStatus = void 0;
const t = require("io-ts");
var VektorioSyncStatus;
(function (VektorioSyncStatus) {
    VektorioSyncStatus["PENDING"] = "pending";
    VektorioSyncStatus["IN_PROGRESS"] = "in_progress";
    VektorioSyncStatus["FAILURE"] = "failure";
    VektorioSyncStatus["SUCCESS"] = "success";
})(VektorioSyncStatus = exports.VektorioSyncStatus || (exports.VektorioSyncStatus = {}));
exports.iVektorioSyncStatus = t.union([
    t.literal(VektorioSyncStatus.PENDING),
    t.literal(VektorioSyncStatus.IN_PROGRESS),
    t.literal(VektorioSyncStatus.FAILURE),
    t.literal(VektorioSyncStatus.SUCCESS)
]);
exports.iVektorioApiKey = t.interface({
    apiKey: t.string
});
exports.iVektorioProject = t.interface({
    vektorioId: t.string,
    name: t.string
});
const iVektorioIds = t.interface({
    vektorioIds: t.array(t.string)
});
exports.iConnectVektorioProjects = t.intersection([
    exports.iVektorioApiKey,
    iVektorioIds
]);
exports.iDisconnectVektorioProjects = iVektorioIds;
exports.ROOT = 'ROOT';
exports.PATH = 'PATH';
exports.iLinkModes = t.keyof({
    [exports.ROOT]: null,
    [exports.PATH]: null
});
exports.iLinkFolders = t.interface({
    mode: exports.iLinkModes,
    folderIds: t.array(t.string)
});
exports.iLinkedFolder = t.interface({
    folderId: t.string,
    folderUuid: t.string,
    folderSyncStatus: t.union([exports.iVektorioSyncStatus, t.null]),
    sokopro: t.string,
    vektorio: t.string,
    mode: exports.iLinkModes
});
//# sourceMappingURL=vektorio.js.map